"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _isGranted = _interopRequireDefault(require("../../utils/isGranted"));

var _selectors = require("../../selectors");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var useIsUserGranted = function useIsUserGranted() {
  var userPermissions = (0, _reactRedux.useSelector)(_selectors.getUserPermissions);

  var isUserGranted = function isUserGranted(requiredPermissions) {
    return (0, _isGranted.default)(userPermissions, requiredPermissions);
  };

  return [isUserGranted];
};

var _default = useIsUserGranted;
exports.default = _default;